// extracted by mini-css-extract-plugin
export default {"container":"Tables_container__ruQQ7","card":"Tables_card__ZxyWb","cardStatus":"Tables_cardStatus__Kv2t7"};